'use es6';

export const currentQuerySelector = state => state.getIn(['queryParams']);
export const currentParamsSelector = state => state.getIn(['pathParams']);